import React from 'react';

import { Tooltip } from '../Tooltips/Tooltip';

export type FollowUpActionProps = {
    label: string;
    icon: React.ElementType;
    iconOnly?: boolean;
    isDisabled?: boolean;
    onClick?: React.MouseEventHandler;
    labelClassName?: string;
    buttonClassName?: string;
};

const FollowUpActionComponent: React.FC<FollowUpActionProps> = ({
    iconOnly,
    isDisabled,
    label,
    onClick,
    icon: Icon,
    labelClassName,
    buttonClassName,
}) => {
    if (iconOnly) {
        return (
            <Tooltip hasArrow placement="top" label={label}>
                <button onClick={onClick} className={buttonClassName} disabled={isDisabled}>
                    <Icon />
                </button>
            </Tooltip>
        );
    }

    return (
        <button onClick={onClick} className={buttonClassName} disabled={isDisabled}>
            <Icon />
            <span className={labelClassName}>{label}</span>
        </button>
    );
};

export const FollowUpAction = React.memo(FollowUpActionComponent);
